
import PropTypes from 'prop-types'
import React from 'react'
import { color } from 'ui/variables'

const Step = props => {
  const { isActive, isComplete, isError } = props

  const style = {
    display: 'block'
  }

  const circleColor = isActive ? color.green['400'] : color.grey['100']

  return (
    <svg style={style} width='21' height='21' viewBox='-1 -1 21 21'>
      {isError && (
        <g fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round' stroke={color.pink['500']} strokeWidth='1.5'>
          <path d='M6.335 6.558l6.417 6.416M12.752 6.558l-6.417 6.416' />
        </g>
      )}
      <circle stroke={circleColor} strokeWidth='1.5' fill='none' cx='9.5' cy='9.5' r='8.761' />
      {isComplete && <path stroke={color.green['400']} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' fill='none' d='M6 10.753l2.67 1.857L13.237 7' />}
    </svg>
  )
}

Step.propTypes = {
  isActive: PropTypes.bool,
  isComplete: PropTypes.bool.isRequired,
  isError: PropTypes.bool
}

Step.displayName = 'Step'

export default Step



// WEBPACK FOOTER //
// ./ui/icons/step.js